import { render, staticRenderFns } from "./PromotionInfographicPreview.vue?vue&type=template&id=4969bde3&scoped=true"
import script from "./PromotionInfographicPreview.vue?vue&type=script&lang=js"
export * from "./PromotionInfographicPreview.vue?vue&type=script&lang=js"
import style0 from "./PromotionInfographicPreview.vue?vue&type=style&index=0&id=4969bde3&prod&scoped=true&lang=css"
import style1 from "./PromotionInfographicPreview.vue?vue&type=style&index=1&id=4969bde3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969bde3",
  null
  
)

export default component.exports